<template>
  <div class="content content--quiz">
    <OverlayLoader v-if="!$store.getters.leaderboardLoaded"></OverlayLoader>
    <div class="bg-img">
      <img src="../../assets/images/hero-quiz.jpg">
    </div>

    <MyHeader :breadcrumbItems="
      [

        {
          name: section.name,
          path: `/${$route.params.companySlug}/quizzes`
        },
        {
          name: 'Leaderboards',
          path: `/${$route.params.companySlug}/quizzes/leaderboard`
        },
        {
          name: quiz.name,
          path: $route.path
        }
      ]"/>

    <header class="content-header">
      <h1>{{ quiz.name }}</h1>
    </header>

    <div class="container main-content">
      <div class="row boxes-row">
        <div class="col-lg-4" v-for="box in leaderboard" :key="box.idUser">
          <LeaderboardPlayerBox :box="box"></LeaderboardPlayerBox>
        </div>
      </div>

      <div class="quiz-info" v-if="onlyPlayer">You are the only player so far!</div>
      <div class="quiz-info" v-else>Here are the players so far!</div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import OverlayLoader from "@/components/general/OverlayLoader";
import LeaderboardPlayerBox from "@/components/quiz/LeaderboardPlayerBox";
export default {
  name: "QuizLeaderboard",
  components: {LeaderboardPlayerBox, OverlayLoader, MyHeader},
  mounted() {
    this.$store.dispatch('getLeaderboard', this.$route.params.id)
    this.$store.dispatch('getQuiz', this.$route.params.id)
  },
  computed: {
    onlyPlayer() {
      return this.leaderboard.length === 1 && this.leaderboard[0].idUser === this.$store.getters.user.idUser
    },
    quiz() {
      return this.$store.getters.quiz
    },
    leaderboard() {
      return this.$store.getters.leaderboard
    },
    company() {
      return this.$store.getters.company
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'QuizIndex'
      })
    },
  },
}
</script>